<template>
    <!-- <div class="d-flex align-center flex-column"> -->
    <v-card>
        <s-toolbar label="IMPRESIÓN DE VISITA TÉCNICA" dark :color="'#8e8f91'" close @close="$emit('close')"
            class="mb-6"></s-toolbar>

        <v-card-title class="pa-0">
            <v-container fluid class="pa-0 pb-2">
                <v-row align="center" justify="center" dense>
                    <!-- Botón de impresión -->
                    <v-col v-if="!isGenerating" cols="auto">
                        <v-btn fab x-small color="info" :loading="isGenerating || isShowing"
                            :disabled="isGenerating || isShowing" @click="downloadPdf()">
                            <v-icon>mdi-printer</v-icon>
                        </v-btn>
                    </v-col>

                    <!-- Barra de progreso -->
                    <v-col v-if="isGenerating || isShowing" cols="12" sm="8" md="6">
                        <v-progress-linear :value="generationProgress" color="info" height="25" class="mb-2">
                            <strong>{{ Math.ceil(generationProgress) }}%</strong>
                        </v-progress-linear>
                        <div class="text-center caption">{{ progressMessage }}</div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-title>
        <!-- <hr> -->

        <vue-html2pdf v-show="false" :show-layout="false" :float-layout="false" :enable-download="false"
            :preview-modal="false" filename="temp.pdf" :paginate-elements-by-height="0" :pdf-quality="2"
            pdf-format="a4" pdf-orientation="portrait" pdf-content-width="80mm" :manual-pagination="true"
            :margin="0" :htmlToPdfOptions="htmlToPdfOptions" @beforeDownload="beforeDownload($event)" ref="html2Pdf">
            <section slot="pdf-content" class="ticket">
                <div v-for="(item, index) in currentBatchItems" :key="index">
                    <div
                        style="width: 80mm;margin: 0 auto; box-sizing: border-box; font-size: 11px; background: white;">

                        <div style="width: 100%;padding: 10px;">
                            <div style="text-align: center; margin-bottom: 16px;">
                                <div style="text-decoration: none; font-weight: bold; font-size: 14px;">
                                    VISITA TÉCNICA
                                </div>
                                <div style="text-decoration: none; font-weight: bold; font-size: 14px;">
                                    {{ item.VstSerie }}-{{ item.VstNumber }}
                                </div>
                            </div>

                            <p style="padding: 2px 0;margin: 0;font-size: 11px;">FECHA VISITA :
                                {{ $fun.formatDateView(item.VstDate) }}</p>
                            <p style="padding: 2px 0;margin: 0;font-size: 11px;">SUPERVISOR :
                                <strong>{{ item.NtpSupervisorName }}</strong>
                            </p>
                            <p style="padding: 2px 0;margin: 0;font-size: 11px;">FUNDO :
                                <strong>{{ item.FagName }}</strong>
                            </p>
                            <p style="padding: 2px 0;margin: 0;font-size: 11px;">PRODUCTOR :
                                <strong>{{ item.PrdCardName }}</strong>
                            </p>
                            <p style="padding: 2px 0;margin: 0;font-size: 11px;">DIRECCIÓN :
                                <strong>{{ item.FagAddress }}</strong>
                            </p>
                            <p style="padding: 2px 0;margin: 0;font-size: 11px;">CAMPAÑA :
                                <strong>{{ item.CmaName }}</strong>
                            </p>

                            <template v-if="item.TasVisitRecomendationHeads.length > 0">
                                <div style="margin: 12px 0 0 0; text-align: center;font-size: 11px;">
                                    <strong>RECOMENDACIONES</strong>
                                </div>
                                <table style="width: 100%;display: table;font-size: 10px;">
                                    <tbody>
                                        <tr v-for="(reco) in item.TasVisitRecomendationHeads" :key="reco.RchID">
                                            <td>
                                                <strong>[{{ reco.CountProduct }}] </strong>
                                                {{ reco.ConcatProducts }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>

                            <template v-if="item.TasVisitActivityCulturals.length > 0">
                                <div style="margin: 12px 0 0 0; text-align: center;font-size: 11px;">
                                    <strong>ACTIVIDADES CULTURALES</strong>
                                </div>
                                <table style="width: 100%;display: table;font-size: 10px;">
                                    <thead style="">
                                        <tr>
                                            <th
                                                style="padding: 2px;border-bottom: 1px dashed #222;text-align: left; width: 30px;">
                                                ITEM</th>
                                            <th style="padding: 2px;border-bottom: 1px dashed #222;text-align: left;">
                                                DESCRIPCIÓN</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(cult) in item.TasVisitActivityCulturals" :key="cult.AcuID">
                                            <td>{{ cult.Line }}</td>
                                            <td>
                                                {{ cult.TypeActivityName }}
                                                <div v-if="cult.AcuObservation">
                                                    {{ cult.AcuObservation }}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>

                            <template v-if="item.TasVisitRecomendationObs.length > 0">
                                <div style="margin: 12px 0; text-align: center;font-size: 11px;">
                                    <strong>OBSERVACIONES</strong>
                                </div>
                                <table style="width: 100%;display: table;font-size: 10px;">
                                    <tbody>
                                        <tr v-for="(observ) in item.TasVisitRecomendationObs" :key="observ.RobID">
                                            <td>
                                                {{ observ.RobObs }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>
                        </div>
                    </div>

                    <!-- <div class="html2pdf__page-break" /> -->
                </div>
            </section>
        </vue-html2pdf>
        <section style="padding-bottom: 40px;">
            <div v-for="(item, index) in items" :key="index">
                <div
                    style="width: 80mm;margin: 0 auto; box-sizing: border-box; font-size: 11px; background: white; border: 1px dashed #ccc;">

                    <div style="width: 100%;padding: 10px;">
                        <div style="text-align: center; margin-bottom: 16px;">
                            <div style="text-decoration: none; font-weight: bold; font-size: 14px;">
                                VISITA TÉCNICA
                            </div>
                            <div style="text-decoration: none; font-weight: bold; font-size: 14px;">
                                {{ item.VstSerie }}-{{ item.VstNumber }}
                            </div>
                        </div>

                        <p style="padding: 2px 0;margin: 0;font-size: 11px;">FECHA VISITA :
                            {{ $fun.formatDateView(item.VstDate) }}</p>
                        <p style="padding: 2px 0;margin: 0;font-size: 11px;">SUPERVISOR :
                            <strong>{{ item.NtpSupervisorName }}</strong>
                        </p>
                        <p style="padding: 2px 0;margin: 0;font-size: 11px;">FUNDO :
                            <strong>{{ item.FagName }}</strong>
                        </p>
                        <p style="padding: 2px 0;margin: 0;font-size: 11px;">PRODUCTOR :
                            <strong>{{ item.PrdCardName }}</strong>
                        </p>
                        <p style="padding: 2px 0;margin: 0;font-size: 11px;">DIRECCIÓN :
                            <strong>{{ item.FagAddress }}</strong>
                        </p>
                        <p style="padding: 2px 0;margin: 0;font-size: 11px;">CAMPAÑA :
                            <strong>{{ item.CmaName }}</strong>
                        </p>

                        <template v-if="item.TasVisitRecomendationHeads.length > 0">
                            <div style="margin: 12px 0 0 0; text-align: center;font-size: 11px;">
                                <strong>RECOMENDACIONES</strong>
                            </div>
                            <table style="width: 100%;display: table;font-size: 10px;">
                                <tbody>
                                    <tr v-for="(reco) in item.TasVisitRecomendationHeads" :key="reco.RchID">
                                        <td>
                                            <strong>[{{ reco.CountProduct }}] </strong>
                                            {{ reco.ConcatProducts }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>

                        <template v-if="item.TasVisitActivityCulturals.length > 0">
                            <div style="margin: 12px 0 0 0; text-align: center;font-size: 11px;">
                                <strong>ACTIVIDADES CULTURALES</strong>
                            </div>
                            <table style="width: 100%;display: table;font-size: 10px;">
                                <thead style="">
                                    <tr>
                                        <th
                                            style="padding: 2px;border-bottom: 1px dashed #222;text-align: left; width: 30px;">
                                            ITEM</th>
                                        <th style="padding: 2px;border-bottom: 1px dashed #222;text-align: left;">
                                            DESCRIPCIÓN</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(cult) in item.TasVisitActivityCulturals" :key="cult.AcuID">
                                        <td>{{ cult.Line }}</td>
                                        <td>
                                            {{ cult.TypeActivityName }}
                                            <div v-if="cult.AcuObservation">
                                                {{ cult.AcuObservation }}
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>

                        <template v-if="item.TasVisitRecomendationObs.length > 0">
                            <div style="margin: 12px 0; text-align: center;font-size: 11px;">
                                <strong>OBSERVACIONES</strong>
                            </div>
                            <table style="width: 100%;display: table;font-size: 10px;">
                                <tbody>
                                    <tr v-for="(observ) in item.TasVisitRecomendationObs" :key="observ.RobID">
                                        <td>
                                            {{ observ.RobObs }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </div>
                </div>

                <div class="html2pdf__page-break" />
            </div>
        </section>
    </v-card>
    <!-- </div> -->
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import QrcodeVue from "qrcode.vue";
import { PDFDocument } from 'pdf-lib';
import _sServices from "@/services/Technicalassistance/Visit/Visit.js";

export default {
    props: {
        VstID: {
            type: Number,
            default: null,
        },
    },
    components: {
        VueHtml2pdf,
        QrcodeVue
    },
    data() {
        return {
            htmlToPdfOptions: {
                margin: [0, 0, 0, 0],
                filename: 'temp.pdf',
                jsPDF: {
                    unit: 'in',
                    format: 'a4',
                    orientation: 'landscape'
                },
                html2canvas: {
                    useCORS: true,
                    scale: 4,
                },
            },
            BATCH_SIZE: 5,
            currentBatch: 0,
            totalBatches: 0,
            currentBatchItems: [],
            generatedPDFBytes: [],
            isGenerating: false,
            isShowing: false,
            generationProgress: 0,
            progressMessage: '',
            items: [],
        }
    },
    methods: {
        async downloadPdf() {
            if (this.items.length === 0) {
                alert('No hay items para generar el PDF');
                return;
            }

            this.isGenerating = true;
            this.generatedPDFBytes = [];
            this.totalBatches = Math.ceil(this.items.length / this.BATCH_SIZE);
            this.currentBatch = 0;
            this.generationProgress = 0;

            await this.generateNextBatch();
        },

        async generateNextBatch() {
            if (this.currentBatch >= this.totalBatches) {
                await this.mergePDFs();
                return;
            }

            const startIndex = this.currentBatch * this.BATCH_SIZE;
            const endIndex = Math.min(startIndex + this.BATCH_SIZE, this.items.length);

            this.currentBatchItems = this.items.slice(startIndex, endIndex);
            this.progressMessage = `Generando lote ${this.currentBatch + 1} de ${this.totalBatches}`;

            await this.$nextTick();

            setTimeout(() => {

                const contentHeight = this.$refs.html2Pdf.$el.querySelector('.ticket').scrollHeight;
                const mmHeight = contentHeight * 0.264583; // píxeles a mm
                this.$refs.html2Pdf.generatePdf({ pdfFormat: [80, mmHeight] });
            }, 200);
        },

        async beforeDownload({ html2pdf, options, pdfContent }) {
            try {
                const pdfBlob = await html2pdf().set(options).from(pdfContent).toPdf().output('blob');
                const arrayBuffer = await pdfBlob.arrayBuffer();
                this.generatedPDFBytes.push(arrayBuffer);
                this.currentBatch++;
                this.generationProgress = (this.currentBatch / this.totalBatches) * 95;
                await this.generateNextBatch();
            } catch (error) {
                console.error('Error generando lote:', error);
                this.isGenerating = false;
                alert('Error al generar el PDF. Por favor intente nuevamente.');
            }
        },

        async mergePDFs() {
            try {
                this.progressMessage = 'Combinando PDFs...';
                this.generationProgress = 95;

                const mergedPdf = await PDFDocument.create();

                for (const pdfBytes of this.generatedPDFBytes) {
                    const pdf = await PDFDocument.load(pdfBytes);
                    const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
                    copiedPages.forEach((page) => mergedPdf.addPage(page, { expand: true }));
                }

                const mergedPdfBytes = await mergedPdf.save();
                const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });

                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `ASISTENCIA TECNICA ${this.items[0].VstSerie}-${this.items[0].VstNumber}.pdf`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);

                this.progressMessage = '¡Completado!';
                this.generationProgress = 100;

                setTimeout(() => {
                    this.isGenerating = false;
                    this.generationProgress = 0;
                    this.generatedPDFBytes = [];
                }, 1500);

            } catch (error) {
                this.isGenerating = false;
                alert('Error al combinar los PDFs.');
            }
        },
    },
    created() {
        this.isShowing = true;
        _sServices.findById(this.VstID, this.$fun.getUserID()).then((r) => {
            if (r.status == 200) {
                if (r.data.TasVisitActivityCulturals.length > 0) {
                    const { TasVisitActivityCulturals, ...newItem } = r.data;
                    const TasVisitActivityCulturalsFilter = TasVisitActivityCulturals.filter(x => x.AcuStatus == 1) ?? []
                    // console.log({ newItem, TasVisitActivityCulturalsFilter });
                    this.items = [{ ...newItem, TasVisitActivityCulturals: TasVisitActivityCulturalsFilter }]
                } else {
                    this.items = [r.data]
                }
                this.isShowing = false;
                // console.log(this.items);
            }
        }).finally(() => {
            this.isShowing = false;
        });
    }
}
</script>

<style scoped>
.ticket {
    width: 80mm;
    box-sizing: border-box;
}
</style>